export default __webpack_public_path__ + "static/media/dark_ns1.8260323e.svg";